module.exports = __webpack_public_path__ + "static/media/komposto.0a716800.png";